module.exports = __webpack_public_path__ + "static/media/wardrobe.c30e743d.png";